import React, { useEffect, useState } from "react";
import { useAuth } from "../login/authProvider";
import "./mypages.css";
import getDevicesByCompany from "../api/getDevicesByCompany";
import getAllDevicesForAdmin from "../api/getAllDevicesForAdmin";
import { getAllCompanies } from "../api/endpoints";
import getModelKey from "./getModelKey"; 
import { useCompanyScope } from "../context/CompanyScopeContext";


const MyPages = () => {
  const { user, token } = useAuth();
  const [devices, setDevices] = useState([]); 
  const [allDevices, setAllDevices] = useState([]); 
  const [allCompanies, setAllCompanies] = useState([]); 
  //const [selectedCompany, setSelectedCompany] = useState(user?.company || ""); 
  const { selectedCompany, setSelectedCompany } = useCompanyScope();
  const [loading, setLoading] = useState(false);
  const [expiringContracts, setExpiringContracts] = useState([]);
  const [serviceDevices, setServiceDevices] = useState([]);
 const [topModels, setTopModels] = useState({ all: [], mobile: [], computer: [] });
  const [awaitingReturnDevices, setAwaitingReturnDevices] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("all");

  const activeDevices = devices.filter(device => device.Aktivenhet === "JA");

   const [companyInput, setCompanyInput] = useState(selectedCompany || "");

  const normalize = (name) => {
    return name
      ?.trim()                          
      .replace(/\s+/g, " ")              
      .replace(/\bAB\b\.?$/i, "")       
      .trim()                         
      .toLowerCase();             
  };
  
    useEffect(() => {
    setCompanyInput(selectedCompany || "");
  }, [selectedCompany]);

   useEffect(() => {
    if (!user?.isAdmin) return;
    const inputNorm = normalize(companyInput || "");
    if (!inputNorm) {
      setSelectedCompany("Alla företag");
      return;
    }
    const match = allCompanies.find((c) => normalize(c) === inputNorm);
    if (match) setSelectedCompany(match);
  }, [companyInput, allCompanies, user?.isAdmin, setSelectedCompany]);



  useEffect(() => {
    const fetchDevices = async () => {
      setLoading(true);
      try {
        let data;
        if (user?.isAdmin) {
          data = await getAllDevicesForAdmin(token); 
        } else {
          data = await getDevicesByCompany(token, selectedCompany || user?.company);

        }

        setAllDevices(data); 
        setDevices(data.filter(device => device.Title === user?.company)); 
      } catch (error) {
        console.error("Kunde inte hämta enheter:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDevices();
  }, [user?.isAdmin, token, selectedCompany, user?.company]);



  useEffect(() => {
    if (user?.isAdmin) {
      const fetchCompanies = async () => {
        try {
          const data = await getAllCompanies(token);
          setAllCompanies(["Alla företag", ...data]); 
        } catch (error) {
          console.error("Kunde inte hämta företag:", error);
        }
      };
      fetchCompanies();
    }
  }, [user?.isAdmin, token]);



  useEffect(() => {
    if (selectedCompany === "Alla företag") {
      setDevices(allDevices);
    } else {
      const normalizedSelected = normalize(selectedCompany);
  
      const filtered = allDevices.filter(device => 
        normalize(device.Title) === normalizedSelected
      );
  
      setDevices(filtered);
    }
  }, [selectedCompany, allDevices]);



  const toTitleCase = (str) =>
    str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1));



  useEffect(() => {
    if (devices.length === 0) return;


    const today = new Date();
    const sixtyDaysLater = new Date();
    sixtyDaysLater.setDate(sixtyDaysLater.getDate() + 60);

    const expiring = devices.filter((device) => {
      const endDate = new Date(device.Avtalsslut);
      return endDate >= today && endDate <= sixtyDaysLater;
    });

    const uniqueContractsMap = new Map();
expiring.forEach((device) => {
  if (!uniqueContractsMap.has(device.Avtalsnummer)) {
    uniqueContractsMap.set(device.Avtalsnummer, device);
  }
});

const uniqueExpiringContracts = Array.from(uniqueContractsMap.values());
setExpiringContracts(uniqueExpiringContracts);


 
    const inService = devices.filter((device) => device.Service === "Service pågår");
    setServiceDevices(inService);

    const awaitingReturn = devices.filter(
      (device) => device.StatusCommunity === "Inväntar retur, avslut begärt" || device.StatusCommunity === "Inväntar retur, ny enhet begärd"
    );
    setAwaitingReturnDevices(awaitingReturn);




  
    const isMobileBrand = (manufacturer = "", model = "") => {
      const brand = (manufacturer || "").toLowerCase();
      const modelName = (model || "").toLowerCase();
    
      if (brand.includes("apple")) {
        return modelName.includes("iphone") || modelName.includes("ipad");
      }
    
      const mobileBrands = ["samsung", "huawei", "xiaomi", "oneplus", "sony"];
      return mobileBrands.some((b) => brand.includes(b));
    };
    
    const isComputerBrand = (manufacturer = "", model = "") => {
      const brand = (manufacturer || "").toLowerCase();
      const modelName = (model || "").toLowerCase();
    
      if (brand.includes("apple")) {
        return modelName.includes("macbook") || modelName.includes("imac");
      }
    
      const computerBrands = ["hp", "dell", "lenovo", "microsoft", "asus", "acer"];
      return computerBrands.some((b) => brand.includes(b));
    };


    const activeDevices = devices.filter(device => device.Aktivenhet === "JA");
    
    const modelCount = activeDevices.reduce((acc, device) => {
      const manufacturer = device.Tillverkare || "";
      const model = typeof device.Modell === "string" ? device.Modell.trim() : "";
      const key = getModelKey(manufacturer, model);
      if (!key) return acc;

      const type = isMobileBrand(manufacturer, model)
        ? "mobile"
        : isComputerBrand(manufacturer, model)
        ? "computer"
        : "other";

      if (!acc[type]) acc[type] = {};
      if (!acc[type][key]) acc[type][key] = { count: 1 };
      else acc[type][key].count += 1;

      return acc;
    }, { mobile: {}, computer: {}, other: {} });

    const sumCounts = (obj) =>
      Object.values(obj).reduce((sum, entry) => sum + entry.count, 0);

    const formatAndSort = (data) =>
      Object.entries(data)
        .map(([key, value]) => ({
          model: key.replace(/^\w/, (c) => c.toUpperCase()),
          count: value.count,
        }))
        .sort((a, b) => b.count - a.count);

    setTopModels({
      all: formatAndSort({ ...modelCount.mobile, ...modelCount.computer, ...modelCount.other }),
      mobile: formatAndSort(modelCount.mobile),
      computer: formatAndSort(modelCount.computer),
      mobileCount: sumCounts(modelCount.mobile),
      computerCount: sumCounts(modelCount.computer),
    });
  }, [devices]);

    



  return (
    <div className="mypages-container">
      <div className="mypages-header">
      <h2>Mina sidor</h2>

   {(user?.isAdmin || (Array.isArray(user?.companies) && user.companies.length > 1)) && (
  <select
    id="company-select"
    value={selectedCompany || ""}
    onChange={(e) => setSelectedCompany(e.target.value)}
  >
    {(user?.isAdmin ? allCompanies : (user?.companies || [user?.company]).filter(Boolean)).map((companyName, index) => (
      <option key={index} value={companyName}>
        {companyName}
      </option>
    ))}
  </select>
)}
  </div>
  <div className="dashboard-layout">
  <div className="dashboard-left">

        <div className="dashboard-card">
          <h3>Min profil 👤</h3>
          <div className="dashboard-card-content">
            <p><strong>Email:</strong> {user?.email}</p>
            <p><strong>Företag:</strong><br />
  {Array.isArray(user?.companies) && user.companies.length > 1
    ? (
        <>
          {user.companies[0]} &<br />
          {user.companies[1]}
        </>
      )
    : user?.company}
</p>
          </div>
        </div>

        <div className="dashboard-card">
          <h3>Avtal som snart löper ut 📅</h3>
          <div className="dashboard-card-content">
            <p><strong>{expiringContracts.length}</strong> avtal löper ut inom 60 dagar</p>
            {expiringContracts.length > 0 && (
              <ul>
                {expiringContracts.map((device, index) => (
                  <li key={index}><strong>Avtalsnummer:</strong> {device.Avtalsnummer}</li>
                ))}
              </ul>
            )}
          </div>
        </div>

        <div className="dashboard-card">
  <h3>Pågående returer 📦</h3>
  <div className="dashboard-card-content">
    <p><strong>{awaitingReturnDevices.length}</strong> enheter väntar på att returneras</p>
    {awaitingReturnDevices.length > 0 && (
      <ul>
        {awaitingReturnDevices.map((device, index) => (
          <li key={index}><strong>{device.Anv_x00e4_ndare}</strong> - {device.Modell}</li>
        ))}
      </ul>
    )}
  </div>
</div>
<div className="dashboard-card">
          <h3>Enheter på service 🔧</h3>
          <div className="dashboard-card-content">
            <p><strong>{serviceDevices.length}</strong> enheter är för närvarande på service</p>
            {serviceDevices.length > 0 && (
              <ul>
                {serviceDevices.map((device, index) => (
                  
                  <li key={index}><strong>{device.Anv_x00e4_ndare}</strong> - {device.Modell} </li>
                ))}
              </ul>
            )}
          </div>
        </div>

        <div className="dashboard-card">
          <h3>Kontakta oss 💬</h3>
          <div className="dashboard-card-content">
            <p>Har du frågor eller behöver du hjälp med dina avtal?</p>
            <p>📧 <a href="mailto:support@communitysverige.se">support@communitysverige.se</a></p>
            <p>📞 <a href="callto:+46868433030">08-684 33 030</a></p>
            <p>🌍 <a href="http://communitysverige.se" target="_blank" rel="noopener noreferrer">Besök vår hemsida</a></p>
          </div>
        </div>
        <div className="dashboard-card">
  <h3>Totalt aktiva enheter ✅</h3>
  <div className="dashboard-card-content">
    <p><strong>{activeDevices.length}</strong> aktiva enheter registrerade i systemet.</p>
    <p>📱 <strong>Mobiler:</strong> {topModels.mobileCount || 0} &nbsp;&nbsp;&nbsp; 💻 <strong>Datorer:</strong> {topModels.computerCount || 0}</p>
  </div>
</div>
        </div>


        <div className="dashboard-right">
        <div className="dashboard-card tall-card">
  <h3>Enhetsstatistik 📊</h3>
  <div className="filter-buttons-inside-card">
  <button
    className={selectedCategory === "all" ? "active" : ""}
    onClick={() => setSelectedCategory("all")}
  >
    Alla 📊 
  </button>
  <button
    className={selectedCategory === "computer" ? "active" : ""}
    onClick={() => setSelectedCategory("computer")}
  >
    Datorer 💻 
  </button>
  <button
    className={selectedCategory === "mobile" ? "active" : ""}
    onClick={() => setSelectedCategory("mobile")}
  >
    Mobiler 📱
  </button>
</div>
  <div className="dashboard-card-content">
  {topModels[selectedCategory]?.length > 0 ? (
      <ul className="popular-models-list">
        {topModels[selectedCategory].map((item, index) => (
          <li key={index}>
            <span className="model-name">{index + 1}. {item.model}</span>
            <div className="model-progress-bar">
              <div className="model-progress-fill" style={{ width: `${(item.count / topModels.all[0].count) * 100}%` }}>
                {item.count} st
              </div>
            </div>
          </li>
        ))}
      </ul>
    ) : <p>Ingen data tillgänglig.</p>}
  </div>
 

</div>

</div>

      </div>
      </div>

  );
};


export default MyPages;
